import React, { useState, useRef } from "react";
import { Form } from 'react-bootstrap';
import { UserTypes } from '../../constants';

export const AddUserBlock = ({ pageLanguage, lesson, addUser, importUsers, loading }) => {

    const [formUserEmail, setFormUserEmail] = useState({ type: UserTypes.Single });
    const fileInputRef = useRef(null);

    const newEmailHandler = (event) => {
        setFormUserEmail({ ...formUserEmail, [event.target.name]: event.target.value, language: pageLanguage })
    }

    const changeUserType = e => {
        setFormUserEmail({ ...formUserEmail, type: Number(e.target.value) });
    }

    const clearInput = () => setFormUserEmail(prev => ({ email: '', type: prev.type }));

    return (
        <div className="mt-1 mb-2 w-100">
            <div className="TabInputBlock">
                <Form.Control
                    custom
                    className="BoxShadow mr-3"
                    as="select"
                    onChange={changeUserType}
                    style={{
                        height: '50px',
                        fontWeight: '200',
                        fontSize: '22px',
                        maxWidth: 400,
                    }}
                    value={formUserEmail.type}>
                    <option value={UserTypes.Single}>Single User</option>
                    <option value={UserTypes.Team}>Team User</option>
                </Form.Control>
                <input
                    className="FormInput BoxShadow"
                    type="text"
                    placeholder="Email"
                    name="email"
                    onChange={(e) => newEmailHandler(e)}
                    value={formUserEmail.email}
                />
                <button
                    className="ElementButton"
                    type="submit"
                    variant="success"
                    disabled={loading}
                    onClick={(e) => {
                        addUser([formUserEmail]);
                        clearInput();
                    }}
                >
                    Add One User
                </button>
                <button
                    className="ElementButton"
                    type="submit"
                    variant="success"
                    disabled={loading}
                    onClick={() => {
                        fileInputRef.current.click();
                    }}
                >
                    Import Users List
                </button>
                <input
                    hidden
                    type="file"
                    ref={fileInputRef}
                    name="import_users"
                    accept=".csv"
                    onChange={(e) => {
                        importUsers(e.target.files[0]);
                        e.target.value = '';
                    }}
                />
            </div>
        </div>
    )
};
